import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import { Link, Redirect } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/modal.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import SelectClass from "../ChildComponent/SelectClass";

const MdlSelectMultipleStudentMultipleClass = ({
  actionClose,
  actionHandleSelected,
}) => {
  const slt_board = useRef();
  const slt_medium = useRef();
  const slt_class = useRef();
  const slt_section = useRef();

  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("token") !== null
  );
  const [loading, setLoading] = useState(false);
  const [loadingStudent, setLoadingStudent] = useState(false);
  const [show, setShow] = useState(true);
  const [selectedClassPosition, setSelectedClassPosition] = useState(0);
  const [studentList, setStudentList] = useState([]);
  const [mSelectedStudent, setMSelectedStudent] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    localStorage.setItem("SelectedMultipleStudent", JSON.stringify([]));
  }, []);

  const callBackClassSelect = (
    class_id,
    section_id,
    session_id,
    selected_position,
    class_name,
    section_name,
    session_name
  ) => {
    //setMSelectedStudent([]);
    // localStorage.setItem("SelectedMultipleStudent", JSON.stringify([]));
    setSelectAll(false);

    setSelectedClassPosition(selected_position);
    getStudentList(class_id, section_id, session_id);
  };

  const getStudentList = (class_id, section_id, session_id) => {
    setLoadingStudent(true);
    setStudentList([]);

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getCurrentStudent.php?";
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          class_id,
          section_id,
          session_id,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoadingStudent(false);
        if (response.api_status === "OK") {
          setStudentList(response.data);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoadingStudent(false);
        console.error("Error fetching students:", error);
      });
  };

  const handleStudentSelection = (e, index) => {
    const isChecked = e.target.checked;
    const student = studentList[index];
    let updatedSelectedStudents = [...mSelectedStudent];

    if (isChecked) {
      updatedSelectedStudents.push(student);
    } else {
      updatedSelectedStudents = updatedSelectedStudents.filter(
        (s) => s.student_enrollment_no !== student.student_enrollment_no
      );
    }

    setMSelectedStudent(updatedSelectedStudents);
    localStorage.setItem(
      "SelectedMultipleStudent",
      JSON.stringify(updatedSelectedStudents)
    );
    
    // Update selectAll state based on current class selection
    if (updatedSelectedStudents.length === studentList.length && studentList.length > 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };
  const handleSelectAll = () => {
    let updatedSelection = [];

    if (!selectAll) {
      // Merge studentList into mSelectedStudent, avoiding duplicates
      const existingIds = new Set(
        mSelectedStudent.map((s) => s.student_enrollment_no)
      );
      updatedSelection = [
        ...mSelectedStudent,
        ...studentList.filter((s) => !existingIds.has(s.student_enrollment_no)),
      ];
    } else {
      // Remove any students in studentList from mSelectedStudent
      const studentIdsToRemove = new Set(
        studentList.map((s) => s.student_enrollment_no)
      );
      updatedSelection = mSelectedStudent.filter(
        (s) => !studentIdsToRemove.has(s.student_enrollment_no)
      );
    }

    setMSelectedStudent(updatedSelection);
    localStorage.setItem(
      "SelectedMultipleStudent",
      JSON.stringify(updatedSelection)
    );
    setSelectAll(!selectAll);
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <div>
      <Modal
        show={show}
        onHide={actionClose}
        animation={false}
        className="fullscreen-modal hide-scrollbar"
        dialogClassName="fullscreen-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          style={{
            background: COLORS.primary_color_shade5,
            color: COLORS.white,
          }}
        >
          <Modal.Title>Select Students (Multiple Classes)</Modal.Title>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <div className="text-white fw-bold" style={{ fontSize: "1.2rem" }}>
              Selected Students: {mSelectedStudent.length}
            </div>
            <Button
              className="margin_0"
              variant={selectAll ? "outline-danger" : "outline-light"}
              size="sm"
              onClick={handleSelectAll}
              style={{ fontSize: "1rem", height: "30px" }}
            >
              {selectAll ? "Deselect All" : "Select All"}
            </Button>
            <Button
              className="margin_0 gravity_center"
              variant="outline-light"
              onClick={actionClose}
              style={{ fontSize: "2rem", height: "30px" }}
              title="Close"
            >
              &times;
            </Button>
            <Button
              className="margin_0"
              variant="primary"
              size="sm"
              onClick={() => actionHandleSelected(mSelectedStudent)}
              disabled={mSelectedStudent.length === 0}
              style={{ fontSize: "1rem", height: "30px" }}
            >
              Done
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body className="hide-scrollbar">
          {loading && (
            <div>
              <MyLoader />
            </div>
          )}
          <div className="row settings-scroll">
            <div className="col-md-12 padding_0">
              <SelectClass
                action={callBackClassSelect}
                selected_position={selectedClassPosition}
              />
              
              <div className="row bg_card_primary_outline" style={{ margin: "2px 10px", padding: "5px" }}>
                {loadingStudent ? (
                  <div className="col-12 text-center">
                    <MyLoader />
                  </div>
                ) : (
                  studentList.map((item, index) => (
                    <div key={index} className="col-md-6 col-lg-4 padding_0">
                      <div
                        className={
                          mSelectedStudent.some((s) => s.student_enrollment_no === item.student_enrollment_no)
                            ? "bg_card_green_outline margin_5 padding_5"
                            : "bg_card_grey_outline margin_5 padding_5"
                        }
                        style={{ 
                          cursor: "pointer",
                          borderRadius: "10px",
                          transition: "all 0.3s ease",
                          minHeight: "90px"
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          const isCurrentlySelected = mSelectedStudent.some((s) => s.student_enrollment_no === item.student_enrollment_no);
                          console.log('Student clicked:', item.stu_name, 'Currently selected:', isCurrentlySelected);
                          handleStudentSelection({ target: { checked: !isCurrentlySelected } }, index);
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <div
                              className="circular_image"
                              style={{
                                width: "70px",
                                height: "70px",
                                borderRadius: "50%",
                                overflow: "hidden",
                                position: "relative"
                              }}
                            >
                              <img 
                                src={item.student_img_path} 
                                alt="" 
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: "0",
                                  left: "0",
                                  right: "0",
                                  background: "rgba(0,0,0,0.7)",
                                  color: "white",
                                  fontSize: "8px",
                                  textAlign: "center",
                                  padding: "2px"
                                }}
                              >
                                {item.student_enrollment_no}
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="mb-1 fw-bold">{item.stu_name}</h5>
                            <p className="mb-1 text-muted">
                              <strong>Father:</strong> {item.father_name}
                            </p>
                            <p className="mb-1 text-muted">
                              <strong>Village/Town:</strong> {item.village_town}
                            </p>
                            <p className="mb-0 text-muted small">
                              <strong>Class:</strong> {item.section_id === "No" ? item.class_name : `${item.class_name}:${item.section_name}`} | 
                              <strong>Roll:</strong> {item.student_roll_no} | 
                              <strong> SRN:</strong> {item.sr_admission_no}  
                              
                            </p>
                            
                          </div>
                          <div className="ms-2">
                            <div
                              style={{
                                background: mSelectedStudent.some((s) => s.student_enrollment_no === item.student_enrollment_no) ? "#28a745" : "#fff",
                                color: mSelectedStudent.some((s) => s.student_enrollment_no === item.student_enrollment_no) ? "#fff" : "#000",
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "18px",
                                border: "2px solid #ddd"
                              }}
                            >
                              {mSelectedStudent.some((s) => s.student_enrollment_no === item.student_enrollment_no) ? "✓" : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MdlSelectMultipleStudentMultipleClass;
